import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import { getDevKeys, updateDevKey, addNewDevKey, deleteDevKey } from '../../../actions/company'
import { getShopList } from '../../../actions/shop'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'

// utils
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import DevKeyItemContainer from '../../../components/DevKeys/DevKeyItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'

const emptyTerminal = {
  name: 'Default',
  enabled: false,
  shopId: '',
}

class CompanyDevKeys extends PureComponent {
  state = {
    showEmptyKey: false,
    selectedToDeleteKey: {},
  }

  componentDidMount() {
    this.props.dispatch(getDevKeys())
    this.props.dispatch(getShopList())
  }

  onDevKeyUpdate = (data, afterOnSave) => {
    if (this.validateDevKey(data)) {
      Appcues.track('Developer key updated')
      this.props.dispatch(updateDevKey(data)).then((response) => {
        this.props.dispatch(getDevKeys())
        afterOnSave(response)
      })
    }
  }

  openDeleteModal = (key) => (e) => {
    this.setState({
      selectedToDeleteKey: key,
    })

    this.deleteModal.handleClickOpen()
  }

  toogleEmptyKey = () => {
    Appcues.track('Adding developer key')
    this.setState((prevState) => ({
      showEmptyKey: !prevState.showEmptyKey,
    }))
  }

  addNewDevKey = (data, afterOnSave) => {
    if (this.validateDevKey(data)) {
      this.props.dispatch(addNewDevKey(data)).then((terminal) => {
        Appcues.track('Added new developer key')
        this.props.dispatch(getDevKeys())
        this.toogleEmptyKey()
      })
    }
  }

  confirmDelete = () => {
    const { selectedToDeleteKey = {} } = this.state
    this.props.dispatch(deleteDevKey(selectedToDeleteKey.id)).then((res) => {
      Appcues.track('Deleted Developer key')
      this.deleteModal.handleClose()
      this.props.dispatch(getDevKeys())
      this.props.dispatch(openSuccessMessage('Dev Key Deleted Successfully'))
    })
  }

  validateDevKey = (devKey) => {
    if (!devKey.shopId) {
      this.props.dispatch(openErrorMessage('Please select a shop'))
      return false
    }
    return true
  }

  render() {
    const { shopsList = {} } = this.props.shopReducer

    const { devKeys = {}, lastModified = null } = this.props.companyReducer

    const { showEmptyKey, selectedToDeleteKey } = this.state

    const shopValues = shopsList.values || []
    const devKeysValues = devKeys.values || []
    const permitted = hasAccess()
    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {permitted ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.toogleEmptyKey}
              >
                Add Key
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table className="developer-keys">
                  <TableHead>
                    <TableRow>
                      <TableCell>Shop Name</TableCell>
                      <TableCell>Key Name</TableCell>
                      <TableCell>Key</TableCell>
                      <TableCell>Secret</TableCell>
                      <TableCell>Created Date</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Expose Sales </TableCell>
                      <TableCell>Expose Members</TableCell>
                      {permitted ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyKey ? (
                      <DevKeyItemContainer
                        devKey={emptyTerminal}
                        lastModified={lastModified}
                        onDevKeyUpdate={this.addNewDevKey}
                        shops={shopValues}
                        onCancel={this.toogleEmptyKey}
                        defaultEditMode={true}
                      />
                    ) : null}
                    {devKeysValues.map((row, index) => {
                      return (
                        <DevKeyItemContainer
                          key={index}
                          devKey={row}
                          lastModified={lastModified}
                          onDevKeyUpdate={this.onDevKeyUpdate}
                          shops={shopValues}
                          onDelete={this.openDeleteModal(row)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            confirmText="delete"
            onConfirm={this.confirmDelete}
          >
            Are you sure you want to delete '{selectedToDeleteKey.name}' key
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
}))(ContainerWithTitle(CompanyDevKeys, 'Developer Keys'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyDevKeys.js